module.exports = __webpack_public_path__ + "static/media/tk.c20b26db.svg";